import React, { useState } from "react";
import harnessImage from "../assets/images/harness.png";
function ProductInfo({
  product,
  selectedCondition,
  setSelectedCondition,
  selectedVariant,
  usesVariants
}) {

 
// auto-select cheapest variant



const price =
  selectedVariant?.price ??
  product?.price ??
  0;

  
const formatted = price.toFixed(2).split(".");

const cheapestPrice = Math.min(...(product?.variants || []).map(v => v.price));

  return (


    <div style={styles.container}>
      
      {/* TITLE */}
   <h1 style={styles.title}>
 {product?.title || "Loading..."}
</h1>

<div style={styles.sponsored}>
        {(product?.partType || "FACTORY OEM").toUpperCase()} ⓘ
        </div>

   {product?.badge && (
  <div style={styles.badgeRow}>
  
    <span style={styles.badgeText}>{product.badge}</span>
  </div>
)}
     

      {/* AMAZON CHOICE */}
     

      <hr style={styles.divider} />

      {/* BEST PRICE */}
      <div style={styles.bestPrice}>Eleven Market Value</div>

      {/* PRICE */}
      <div style={styles.priceRow}>
       <span style={styles.dollar}>$</span>
<span style={styles.price}>{formatted[0]}</span>
<span style={styles.cents}>{formatted[1]}</span>
      </div>

      {/* SHIPPING */}
      <div style={styles.shipping}>
        Get <b>Fast, Free Shipping</b> with 1111 
      </div>




{(product?.manufacturer || product?.compatibleModels?.length > 0 || product?.model) && (
  <div style={styles.freeReturns}>
    DIRECT FIT —{" "}
    {product?.compatibleModels?.length > 0
      ? product.compatibleModels.slice(0, 3).join(" · ")
      : [
          product.yearStart && product.yearEnd && product.yearStart !== product.yearEnd
            ? `${product.yearStart}–${product.yearEnd}`
            : product.yearStart || product.yearEnd || "",
          product.manufacturer || "",
          product.model || ""
        ].filter(Boolean).join(" ")
    }
  </div>
)}

     <div style={styles.credit}>
 Pay over time with Shop
From $54/mo with Shop Pay
  <span style={{ color: "#8E8E93", margin: "0 4px", textDecoration: "line-through" }}>
  IN FULL
  </span>

</div> 



{usesVariants && (
  <div>


    <div style={styles.conditionRow}>
      <b>Condition:</b>{" "}
      {selectedVariant?.label || "Select Condition"}
    </div>

    <div style={styles.conditionOptions}>

      {product?.variants?.map((variant) => (

        <div
          key={variant.condition}

          style={{
            ...styles.conditionCard,

            ...(selectedCondition === variant.condition
              ? styles.selected
              : {}),

            opacity:
              variant.stock === 0
                ? 0.5
                : 1,

            pointerEvents:
              variant.stock === 0
                ? "none"
                : "auto"
          }}

          onClick={() =>
            setSelectedCondition(
              variant.condition
            )
          }
        >

          {variant.price === cheapestPrice && (
            <div style={styles.bestValueTag}>
              Best Value
            </div>
          )}

         <img
            src={
              variant?.images?.[0]
                ? `${variant.images[0]}`
                : product?.images?.[0]
                ? `${product.images[0]}`
                : harnessImage
            }

            style={styles.conditionImg}
          />

          
          <div style={styles.conditionInfo}>

            <div style={styles.conditionTitle}>
              {variant.label}
            </div>

            <div style={styles.conditionSubtitle}>
              {variant.condition === "new"
                ? "OEM • Factory Fresh"
                : "OEM Like New • Fully Tested"}
            </div>

            <div style={styles.conditionPrice}>
              ${variant.price.toFixed(2)}
            </div>

            {variant.stock > 0 &&
              variant.stock <= 3 && (
                <div
                  style={{
                    fontSize: 11,
                    color: "#d93025",
                    marginTop: 4
                  }}
                >
                  Only {variant.stock} left
                </div>
              )}

          </div>

        </div>
      ))}

    </div>

   </div>
)}



      {/* PRODUCT SPECS */}
    <div style={styles.specRowContainer}>
<div style={styles.specItem}>
  <div style={styles.specLabel}>Model</div>
  <div style={styles.specValue}>
    {product.model || "—"}
  </div>
</div>


 <div style={styles.specItem}>
  <div style={styles.specLabel}>EID "ELEVEN ID"</div>
  <div style={styles.specValue}>
    {product.eid || "—"}
  </div>
</div>


  <div style={styles.specItem}>
    <div style={styles.specLabel}>Color</div>
 <div style={styles.specValue}>
 {product.color || "—"}
</div>
  </div>

  <div style={styles.specItem}>
    <div style={styles.specLabel}>Item Weight</div>
   <div style={styles.specValue}>
 {product.weightValue ? `${product.weightValue} ${product.weightUnit || ""}` : "—"}
</div>
  </div>

<div style={styles.specItem}>
  <div style={styles.specLabel}>OEM Part #</div>
  <div style={styles.specValue}>
    {product.partNumber || "—"}
  </div>
</div>

  <div style={styles.specItem}>
    <div style={styles.specLabel}>Manufacturer</div>
   <div style={styles.specValue}>
 {product.manufacturer || product.brand || "—"}
</div>
  </div>
</div>
 </div>  

  );
}
export default ProductInfo;

const styles = {
  container: {
    width: 520,
  
  },

  title: {
  fontSize: 26,
  fontWeight: 600,
  lineHeight: "34px",
  letterSpacing: "-0.02em",
  color: "#1d1d1f"
},

sponsored: {
  fontSize: 13,
  color: "#6e6e73",
  marginBottom: 6
},

badgeRow: {
  display: "flex",
  alignItems: "center",
  gap: 6,
  marginTop: 10,
  marginBottom: 2
},
badgeIcon: {
  fontSize: 12
},
badgeText: {
  fontSize: 12,
  fontWeight: 600,
  color: "#3a3a3c",
  background: "linear-gradient(135deg, #f5f5f7 0%, #e8e8ed 100%)",
  padding: "4px 12px",
  borderRadius: 999,
  border: "1px solid rgba(0,0,0,0.08)",
  letterSpacing: "0.2px",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8), 0 1px 3px rgba(0,0,0,0.06)"
},

  saveBadge: {
    background: "#007600",
    color: "white",
    padding: "6px 10px",
    borderRadius: 4,
    marginTop: 8,
    width: 110,
    fontWeight: 600
  },

  choiceBadge: {
    background: "#232F3E",
    color: "white",
    fontSize: 12,
    padding: "4px 8px",
    marginTop: 6,
    width: 120
  },

divider: {
  border: "none",
  height: 18,
  marginTop: 20,
  marginBottom: 20,

  marginLeft: -25,
  marginRight: -10,

  background: "linear-gradient(to bottom, rgba(0,0,0,0.08), rgba(0,0,0,0.02), transparent)",

  WebkitMaskImage: "linear-gradient(to right, transparent, black 15%, black 85%, transparent)",
  maskImage: "linear-gradient(to right, transparent, black 15%, black 85%, transparent)"
},


  bestPrice: {
  marginTop: 0,
    border: "1px solid #ddd",
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: 4,
    fontSize: 13
  },

  priceRow: {
    display: "flex",
    alignItems: "flex-start",
    marginTop: 10
  },

  dollar: {
    fontSize: 16
  },

  price: {
    fontSize: 30,
    fontWeight: 600
  },

  cents: {
    fontSize: 14,
    marginTop: 4
  },

  shipping: {
    marginTop: 10,
    fontSize: 14
  },

  freeReturns: {
    color: "#007185",
    marginTop: 4
  },
credit: {
  marginTop: 16,
  fontSize: 13,
  color: "#8E8E93", // Apple secondary gray
  fontWeight: 400,
  letterSpacing: "0.3px",
  lineHeight: "18px",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', system-ui, sans-serif"
},
  colorRow: {
    marginTop: 14
  },

  colorOptions: {
    display: "flex",
    gap: 10,
    marginTop: 8
  },

  colorCard: {
    border: "1px solid #ddd",
    borderRadius: 6,
    width: 90,
    padding: 6,
    textAlign: "center"
  },

 selected: {
  border: "2px solid #00A6FF",
  boxShadow: "0 6px 16px rgba(0,0,0,0.08)"
},

  colorImg: {
    width: "100%"
  },

  colorPrice: {
    marginTop: 6,
    fontSize: 13
  },






conditionRow: {
  marginTop: 18,
  fontSize: 14,
},

conditionOptions: {
  display: "flex",
  gap: 12,
  marginTop: 10,
},

conditionCard: {
  position: "relative", // 🔥 THIS FIXES EVERYTHING
  flex: 1,
  border: "1px solid #e5e5e5",
  borderRadius: 12,
  padding: 10,
  cursor: "pointer",
  transition: "all 0.2s ease",
  backgroundColor: "#fff",
},

conditionImg: {
  width: "100%",
  height: 110,
  objectFit: "contain",
  transform: "scale(1.08)"
},

conditionInfo: {
  marginTop: 8,
},

conditionTitle: {
  fontSize: 14,
  fontWeight: 600,
},

conditionSubtitle: {
  fontSize: 12,
  color: "#86868B",
  marginTop: 2,
},

conditionPrice: {
  marginTop: 6,
  fontSize: 16,
  fontWeight: 700,
},







specRowContainer: {
  marginTop: 36,
  display: "flex",
  flexWrap: "wrap",
  gap: 28,
  borderTop: "1px solid rgba(0,0,0,0.04)",
  paddingTop: 22
},


specItem: {
  display: "flex",
  flexDirection: "column",
  width: 150,
  alignItems: "flex-start"
},
specLabel: {
  fontSize: 12,
  color: "#86868B",
  fontWeight: 500,
  letterSpacing: "0.02em",
  marginBottom: 6
},

specValue: {
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: "-0.01em",
  color: "#1d1d1f"
},


};